import { BotMappieVersion, PromptUpdateParams } from '@/domain/bot-mappie';

export const getNestedModule = (obj: any, path: string[]) => {
    return path.reduce((prev, curr) => prev && prev[curr], obj);
};

export const updatePromptInMappieBot = (
    botMappie: BotMappieVersion,
    params: PromptUpdateParams,
): BotMappieVersion => {
    const { promptKey, variantIndex, text, language, path, isGlobal } = params;
    const updatedbotMappie = JSON.parse(JSON.stringify(botMappie));

    try {
        if (isGlobal) {
            const globalPrompt = updatedbotMappie.globals.prompts[promptKey];
            if (globalPrompt && globalPrompt.variants) {
                const variants = globalPrompt.variants.lang[language];
                if (variants && variants[variantIndex]) {
                    variants[variantIndex].text = text;
                }
            }
        } else {
            const parentPath = path.slice(0, -2);
            const parent = getNestedModule(updatedbotMappie, parentPath);
            const promptsObjectKey = path[path.length - 2];
            const specificPromptKey = path[path.length - 1];

            if (
                parent &&
                parent[promptsObjectKey] &&
                parent[promptsObjectKey][specificPromptKey]
            ) {
                const promptDef = parent[promptsObjectKey][specificPromptKey];
                if (promptDef.variants) {
                    const variants = promptDef.variants.lang[language];
                    if (variants && variants[variantIndex]) {
                        variants[variantIndex].text = text;
                    }
                }
            }
        }
    } catch (error) {
        console.error('Error updating prompt:', error);
    }

    return updatedbotMappie;
};
